import axios from 'axios'
import { BUSCAR_VENDAS_URBANAS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarVendasUrbanas (idEmpresa, filtro) {
  const params = new URLSearchParams()
  if (filtro.id) params.append('id', filtro.id)
  if (filtro.nomeVendedor) params.append('nomeVendedor', filtro.nomeVendedor)
  if (filtro.nomePassageiro) params.append('nomePassageiro', filtro.nomePassageiro)
  if (filtro.formasPagamento) {
    filtro.formasPagamento.forEach(forma => params.append('formasPagamento', forma))
  }
  if (filtro.valorMinimo) params.append('valorMinimo', filtro.valorMinimo)
  if (filtro.valorMaximo) params.append('valorMaximo', filtro.valorMaximo)
  params.append('from', filtro.from || 0)
  params.append('size', filtro.size || 20)

  const url = `${URL}/vendas-urbanas/empresa/${idEmpresa}?${params.toString()}`
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG).then(
    response => dispatch({
      type: BUSCAR_VENDAS_URBANAS,
      payload: response.data
    })
  ).catch(erro => {
    if (!navigator.onLine || !erro.response) {
      return dispatch({ type: BUSCAR_VENDAS_URBANAS, payload: { vendasUrbanas: [], total: 0 } })
    }
    throw erro
  })
}
